/** @jsx jsx */
import GatsbyLink from 'gatsby-link'
import {jsx} from 'theme-ui'
const Link = ({ children, to, ...other }) => {
  const internal = /^\/(?!\/)/.test(to)
 
 const color = 'black'
  if (internal) {
    return (
      <GatsbyLink sx={{ color:`${color}`}}to={to} {...other}>
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a sx={{color:`${color}`}} href={to} rel="noreferrer noopener" {...other}>
      {children}
    </a>
  )
}

export default Link
  